import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import './customiseCover.scss';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';
import ValidationMessage from '../question/ValidationMessage';

export default function CustomiseCover(props: any) {

    const [question, setQuestion] = useState(props.question);
    const [radioValue, setRadioValue] = useState(props.question.answer);

    var containerClasses = classNames(
        {
            'question-customise-cover': true,
            'customise-cover-selected': radioValue === "1",
            'validation-fail-lbl': question.validationFail
        }
    );

    var yesInputClasses = classNames(
        {
            'question-customise-cover': true,
            'yes-selected': radioValue === "1"
        }
    );

    var noInputClasses = classNames(
        {
            'question-customise-cover': true,
            'no-selected': radioValue === "0"
        }
    );

    useEffect(() => {
        setQuestion(props.question);
        if (props.question.answer) {
            setRadioValue(props.question.answer);
        } else {
            setRadioValue("0");
        }
    }, [])

    useEffect(() => {
        question.answer = radioValue;
        setQuestion(question);
        props.showConditionQuestions(question.questionSetQuestion.questionID, radioValue);
        props.resetCoverValidation();
    }, [radioValue]);

    const updateAnswer = (answer: string) => {
        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
        setRadioValue(answer);
        question.validationFail = false;
        setQuestion(question);
    }

    return (
        <>
            <div className={containerClasses}>
                <p>{question.questionSetQuestion.text}</p>
                <div className="customise-cover-container">
                    <span className="customise-help">{props.question.questionSetQuestion.helpText}</span>
                    <div className="btn-container-customise-cover">
                        <button
                            value={radioValue}
                            id={"valen_" + question.questionSetQuestion.questionID}
                            name={question.questionSetQuestion.questionID}
                            className={noInputClasses}
                            onClick={() => updateAnswer("0")}
                        >Don't include this cover</button>

                        <button
                            value={radioValue}
                            id={"valen_" + question.questionSetQuestion.questionID}
                            name={question.questionSetQuestion.questionID}
                            className={yesInputClasses}
                            onClick={() => updateAnswer("1")}
                        >Include this cover</button>

                    
                    </div>
                    </div>
                <br />
                {question.validationFail &&
                    <ValidationMessage question={question} overrideMessage="Please select an option" />}
            </div>
          
        </>

    )
}